import { API } from "@/lib/api";

export const FONTS = ["DM Sans", "Cabinet Grotesk", "Playfair Display", "Merriweather", "Lora", "Montserrat", "Nunito"];
export const SIZES = [{ value: "sm", label: "Small" }, { value: "md", label: "Medium" }, { value: "lg", label: "Large" }, { value: "xl", label: "Extra large" }];
export const HEIGHT_OPTIONS = [{ value: "sm", label: "Short" }, { value: "md", label: "Medium" }, { value: "lg", label: "Tall" }, { value: "full", label: "Full height" }];
export const DIVIDER_STYLES = [{ value: "solid", label: "Solid line" }, { value: "dashed", label: "Dashed line" }, { value: "dotted", label: "Dotted line" }, { value: "double", label: "Double line" }];
export const TITLE_PX = { sm: 20, md: 28, lg: 40, xl: 56 };
export const BODY_PX = { sm: 14, md: 16, lg: 19, xl: 22 };
export const HEIGHT_PX = { sm: 180, md: 300, lg: 440, full: 520 };
export const SWATCHES = ["#6b1e2e", "#4e1420", "#1e293b", "#ffffff", "#f5f1e8", "#c98a1b", "#226b4b", "#000000"];
export const BLOCK_TYPES = [
  { type: "banner", label: "Banner" },
  { type: "text", label: "Text section" },
  { type: "image", label: "Image" },
  { type: "divider", label: "Divider" },
];
export const PAGES = [
  { key: "front", label: "Front page (login)" },
  { key: "dashboard", label: "Dashboard" },
  { key: "tithes", label: "Tithes" },
  { key: "progress", label: "Progress Report" },
  { key: "donations", label: "Conference Collection" },
  { key: "conference", label: "Conference" },
  { key: "reports", label: "Reports" },
];

export const publicImage = (id) => `${API}/public/images/${id}`;

export const newBlock = (type) => {
  const banner = type === "banner";
  return {
    id: crypto.randomUUID(), type, image_id: null, visible: true, font: banner ? "Cabinet Grotesk" : "DM Sans",
    title: banner ? "New banner" : type === "text" ? "New section" : "", body: "",
    size: banner ? "lg" : "md", color: banner ? "#ffffff" : "#1e293b", bg: banner ? "#6b1e2e" : type === "divider" ? "#f5f1e8" : "#ffffff",
    align: banner ? "center" : "left", height: "md", divider_style: "solid",
  };
};
